import { __awaiter } from '../../_virtual/_tslib.js';

function getNullApiResponse() {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((res) => res({ data: null, meta: null }));
    });
}

export { getNullApiResponse };
//# sourceMappingURL=get-null-api-response.js.map
